@if (operatorStateSrv.context(); as context) {
	<section class="workspace">
		<app-operator-reservation-controls
			(createRequested)="openCreate($event)"
			(dateChanged)="expandedReservationId.set(null)"
		/>

		<section class="reservation-list" aria-live="polite">
			@if (operatorStateSrv.loading()) {
				<div class="list-state">Ανανέωση κρατήσεων…</div>
			} @else if (!operatorStateSrv.reservations().length) {
				<div class="empty-state">
					<strong>Δεν υπάρχουν κρατήσεις για αυτή την ημερομηνία</strong>
					<!-- <span>Αλλάξτε ημερομηνία ή καταχωρίστε νέα κράτηση.</span> -->
				</div>
			} @else {
				@for (reservation of operatorStateSrv.shiftReservations(); track reservation.id) {
					<app-operator-reservation-card
						[reservation]="reservation"
						[timezone]="context.timezone"
						[expanded]="expandedReservationId() === reservation.id"
						[saving]="operatorStateSrv.saving()"
						(toggled)="toggleReservation(reservation.id)"
						(editRequested)="openEdit(reservation)"
						(transitionRequested)="transition(reservation, $event)"
					/>
				}
			}
		</section>
	</section>
}

@if (editorMode(); as mode) {
	@if (mode === 'walk_in' || editing()?.source === 'walk_in') {
		<app-operator-walk-in-editor
			[reservation]="editing()"
			(closed)="closeEditor()"
		/>
	} @else {
		<app-operator-reservation-editor
			[mode]="mode"
			[reservation]="editing()"
			(closed)="closeEditor()"
		/>
	}
}
